import { LOAD_EVENTS } from '../../db/constants/ActionTypes';

export default (state = [], action) => {
  switch (action.type) {
    case LOAD_EVENTS: {
      return action.payload;
    }
    default:
      return state;
  }
};
